<script></script>

<header>
    <h1>Funds Calculator</h1>
    <slot>
        <span>Default value if none passed in</span>
    </slot>
</header>

<style>

header, h1{
    margin-top: 0;
    text-align: center;
    background-color: hsl(180,0%,18%);
    padding : 15px;
    color:white;
}

</style>
